import { Capacitor } from '@capacitor/core';
import { addVowelPrefix } from '@deckee/utilities';
import { nativeShare } from '../../services/share';

/**
 * Check to see if the social sharing plugin is available
 *
 * @returns {boolean} True if the plugin exists
 */
export const checkSocialSharingPluginExists = () =>
  Capacitor.isPluginAvailable('Share') && Capacitor.isNativePlatform();

/**
 * Format a url link string from a given path
 *
 * @param {string} path - supplied path to use for the url link
 * @returns {string} Formatted marker link string
 */
export const getURLFromPath = (path) => {
  const { hostname } = window.location;
  const namespace = hostname.split('.')[0];
  return `https://${
    namespace !== 'deckee' ? 'staging.' : ''
  }deckee.com/maps/${path}`;
};

/**
 * Format a url link string from a given path
 *
 * This exists to provide the full path, typically starting with /maps
 *
 * @param {string} path - supplied path to use for the url link
 * @returns {string} Formatted marker link string
 */
export const getRawURLFromPath = (path) => {
  const { hostname } = window.location;
  const namespace = hostname.split('.')[0];
  return `https://${namespace !== 'deckee' ? 'staging.' : ''}deckee.com${path}`;
};

/**
 * Action to invoke the native share dialog
 *
 * @param {string} path - supplied path to use for the url link
 * @param {string} sharingText - text to use for sharing dialog
 * @returns {string} Formatted marker link string
 */
export const nativeShareAction = (path, sharingText) => {
  const linkString = getURLFromPath(path);
  try {
    nativeShare(sharingText, linkString);
  } catch {
    // TODO: we want to know when it fails to show an error to the user.
  }
};

/**
 * Construct the successful sharing message from the share type
 *
 * @param {string} shareItemType - the type of item that was shared
 * @returns {string} Formatted share success message
 */
export const sharingMessageSuccess = (shareItemType) => {
  const shareItemLabel =
    window.DECKEE_CONFIG?.sharing?.itemTypeDisplayNames[shareItemType] ||
    window.DECKEE_CONFIG.sharing.itemTypeDisplayNames.default;
  const shareItemLabelWithVowelPrefix = addVowelPrefix(shareItemLabel);

  const successMessage = `Great, you've shared ${shareItemLabelWithVowelPrefix}!`;

  return successMessage;
};
